// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Vj-z","carouselContainer":"Wj-z","carouselContent":"Xj-z"};